// // src/components/EmployeeBookingAlert.jsx
// import React, { useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import chatWS from "../services/chatWebSocket";
// import bookingWS from "../services/bookingWebSocket"; // Import bookingWS
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const EmployeeBookingAlert = () => {
//   const navigate = useNavigate();
//   const { userDetails, authKey } = useSelector((state) => state.auth);
//   const audioContextRef = useRef(null);

//   // Connect to Chat WS AND Booking WS
//   useEffect(() => {
//     if (!userDetails || !authKey) return;

//     const role = userDetails.role?.toLowerCase() || ""; 
//     const isDriver = role === "driver" || userDetails.role === "D";
//     const isAdmin = role === "admin" || role === "ad";
    
//     console.log("[EmployeeBookingAlert] Checks - isDriver:", isDriver, "isAdmin:", isAdmin);
     
//     if (authKey && userDetails.ServiceNo && !isDriver && !isAdmin) {
//       console.log("[EmployeeBookingAlert] ✅ Connecting as Employee/Supervisor");
 
//       chatWS.connect(authKey, userDetails.ServiceNo, "Employee");

//       const unsubscribeChat = chatWS.onMessage((msg) => {
//         console.log("[EmployeeBookingAlert] 📨 Received from ChatWS:", msg);
//         processMessage(msg);
//       });
 
//       bookingWS.connectAsEmployee(authKey);
      
//       const unsubscribeBooking = bookingWS.onStatusUpdate((msg) => {
//         console.log("[EmployeeBookingAlert] 📨 Received from BookingWS:", msg);
//         processMessage(msg);
//       });

//       return () => {
//         if (unsubscribeBooking) unsubscribeBooking();
//         if (unsubscribeChat) unsubscribeChat();
         
//       };
//     }
//   }, [authKey, userDetails]);

//   const processMessage = (msg) => {
//     console.log("[EmployeeBookingAlert] 🔍 Processing message:", msg);
    
 
//     if ((msg.type === "status_update" || msg.type === "booking_status_update" || msg.status) && msg.bId) {
//       console.log("[EmployeeBookingAlert] ✅ Has bId and status");
      
 
//       if (!userDetails?.ServiceNo) {
//         console.log("[EmployeeBookingAlert] ❌ Ignoring message - User ServiceNo not available");
//         return;
//       }
 
//       if (msg.type === "status_update") {
//         if (!msg.targetUserId || msg.targetUserId === "undefined" || msg.targetUserId === "null") {
//           console.log("[EmployeeBookingAlert] ⚠️ Ignoring chat message with missing/invalid targetUserId:", msg.targetUserId);
//           return;
//         }
//         if (String(msg.targetUserId) !== String(userDetails?.ServiceNo)) {
//           console.log(`[EmployeeBookingAlert] ❌ Ignoring chat message for user ${msg.targetUserId} (I am ${userDetails?.ServiceNo})`);
//           return;
//         }
//       }
  
//       else if (msg.type === "booking_status_update") {
//         if (!msg.bookingSno || msg.bookingSno === "undefined" || msg.bookingSno === "null") {
//           console.log("[EmployeeBookingAlert] ⚠️ Ignoring booking message with missing/invalid bookingSno:", msg.bookingSno);
//           return;
//         }
//         if (String(msg.bookingSno) !== String(userDetails?.ServiceNo)) {
//           console.log(`[EmployeeBookingAlert] ❌ Ignoring booking message for user ${msg.bookingSno} (I am ${userDetails?.ServiceNo})`);
//           return;
//         }
//       }
 
//       else {
//         if (!msg.targetUserId || msg.targetUserId === "undefined" || msg.targetUserId === "null") {
//           console.log("[EmployeeBookingAlert] ⚠️ Ignoring message with missing/invalid targetUserId:", msg.targetUserId);
//           return;
//         }
//         if (String(msg.targetUserId) !== String(userDetails?.ServiceNo)) {
//           console.log(`[EmployeeBookingAlert] ❌ Ignoring message for user ${msg.targetUserId} (I am ${userDetails?.ServiceNo})`);
//           return;
//         }
//       }

//       console.log("[EmployeeBookingAlert] ✅ Message is for THIS employee! Status:", msg.status);

//       if (msg.status === "A" || msg.status === "ACCEPTED") {
//         handleAlert("accepted", msg);
//       } else if (msg.status === "C" || msg.status === "DECLINED" || msg.status === "REJECTED") {
//         handleAlert("declined", msg);
//       }
//     } else {
//       console.log("[EmployeeBookingAlert] ⚠️ Message missing bId or status. Has bId:", !!msg.bId, "Has status:", !!msg.status);
//     }
//   };

//   const playSound = (type) => {
//     try {
//       const AudioContext = window.AudioContext || window.webkitAudioContext;
//       if (!AudioContext) return;
      
//       const ctx = new AudioContext();
//       audioContextRef.current = ctx;
//       const now = ctx.currentTime;

//       if (type === "accepted") {
//         // Success Sound (Positive Chime)
//         const osc = ctx.createOscillator();
//         const gain = ctx.createGain();
//         osc.connect(gain);
//         gain.connect(ctx.destination);
        
//         osc.type = "sine";
//         osc.frequency.setValueAtTime(523.25, now); // C5
//         osc.frequency.exponentialRampToValueAtTime(1046.5, now + 0.1); // C6
        
//         gain.gain.setValueAtTime(0.3, now);
//         gain.gain.exponentialRampToValueAtTime(0.01, now + 0.5);
        
//         osc.start(now);
//         osc.stop(now + 0.5);

//         // Harmony
//         const osc2 = ctx.createOscillator();
//         const gain2 = ctx.createGain();
//         osc2.connect(gain2);
//         gain2.connect(ctx.destination);
        
//         osc2.type = "triangle";
//         osc2.frequency.setValueAtTime(659.25, now); // E5
//         osc2.frequency.exponentialRampToValueAtTime(1318.5, now + 0.1); // E6
        
//         gain2.gain.setValueAtTime(0.3, now);
//         gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.5);
        
//         osc2.start(now);
//         osc2.stop(now + 0.5);

//       } else {
//         // Decline Sound (Negative/Error)
//         const osc = ctx.createOscillator();
//         const gain = ctx.createGain();
//         osc.connect(gain);
//         gain.connect(ctx.destination);
        
//         osc.type = "sawtooth";
//         osc.frequency.setValueAtTime(440, now); // A4
//         osc.frequency.linearRampToValueAtTime(220, now + 0.3); // A3
        
//         gain.gain.setValueAtTime(0.3, now);
//         gain.gain.exponentialRampToValueAtTime(0.01, now + 0.4);
        
//         osc.start(now);
//         osc.stop(now + 0.4);
//       }
//     } catch (e) {
//       console.error("Audio play failed", e);
//     }
//   };

//   // 🔴 NEW: Show employee-style toast with button & sound (global notifications)
//   const showEmployeeStyleToast = (type, bId) => {
//     // Create audio context for sound
//     const playSound = (soundType) => {
//       try {
//         const AudioContext = window.AudioContext || window.webkitAudioContext;
//         if (!AudioContext) return;

//         const ctx = new AudioContext();
//         const now = ctx.currentTime;

//         if (soundType === "accepted") {
//           // Success Sound (Positive Chime)
//           const osc = ctx.createOscillator();
//           const gain = ctx.createGain();
//           osc.connect(gain);
//           gain.connect(ctx.destination);

//           osc.type = "sine";
//           osc.frequency.setValueAtTime(523.25, now); // C5
//           osc.frequency.exponentialRampToValueAtTime(1046.5, now + 0.1); // C6

//           gain.gain.setValueAtTime(0.3, now);
//           gain.gain.exponentialRampToValueAtTime(0.01, now + 0.5);

//           osc.start(now);
//           osc.stop(now + 0.5);

//           // Harmony
//           const osc2 = ctx.createOscillator();
//           const gain2 = ctx.createGain();
//           osc2.connect(gain2);
//           gain2.connect(ctx.destination);

//           osc2.type = "triangle";
//           osc2.frequency.setValueAtTime(659.25, now); // E5
//           osc2.frequency.exponentialRampToValueAtTime(1318.5, now + 0.1); // E6

//           gain2.gain.setValueAtTime(0.3, now);
//           gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.5);

//           osc2.start(now);
//           osc2.stop(now + 0.5);

//         } else {
//           // Decline Sound (Negative/Error)
//           const osc = ctx.createOscillator();
//           const gain = ctx.createGain();
//           osc.connect(gain);
//           gain.connect(ctx.destination);

//           osc.type = "sawtooth";
//           osc.frequency.setValueAtTime(440, now); // A4
//           osc.frequency.linearRampToValueAtTime(220, now + 0.3); // A3

//           gain.gain.setValueAtTime(0.3, now);
//           gain.gain.exponentialRampToValueAtTime(0.01, now + 0.4);

//           osc.start(now);
//           osc.stop(now + 0.4);
//         }
//       } catch (e) {
//         console.error("Audio play failed", e);
//       }
//     };

//     // Show toast with button (same as EmployeeBookingAlert)
//     const message = type === "accepted"
//       ? `Driver accepted hire #${bId}. You can see details on my bookings.`
//       : `Driver declined hire #${bId}. Try another one.`;

//     toast(
//       <div className="flex flex-col sm:flex-row sm:items-center gap-3">
//         <div className="flex-1">
//           <strong>{type === "accepted" ? "Booking Accepted!" : "Booking Declined"}</strong>
//           <div style={{ fontSize: 12 }}>{message}</div>
//         </div>
//         <div className="flex gap-2">
//           {type === "accepted" ? (
//             <button
//               onClick={() => {
//                 toast.dismiss();
//                 navigate("/employee/my-bookings");
//               }}
//               className="bg-green-600 text-white px-3 py-1 rounded"
//             >
//               View Bookings
//             </button>
//           ) : (
//             <button
//               onClick={() => {
//                 toast.dismiss();
//                 navigate("/employee-dashboard");
//               }}
//               className="bg-red-600 text-white px-3 py-1 rounded"
//             >
//               Find Another
//             </button>
//           )}
//         </div>
//       </div>,
//       {
//         autoClose: false,
//         closeButton: true,
//         position: "top-center",
//         style: { minWidth: '400px' }
//       }
//     );
 
//     playSound(type);
//   };

//   const handleAlert = (type, msg) => { 
//     showEmployeeStyleToast(type, msg.bId);
//   };

 
//   return null;
// };

// export default EmployeeBookingAlert;





// src/components/EmployeeBookingAlert.jsx
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import chatWS from "../services/chatWebSocket";
import bookingWS from "../services/bookingWebSocket";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FindNearestDriverAndSendRequest } from "../actions/ScheduleBookingAction";

// ─── Module-level pending booking registry ────────────────────────────────────
// When an employee submits an unplanned booking, call:
//   registerPendingBooking(bId, requestedType, bookingPayload)
// This tells EmployeeBookingAlert what payload + vehicle type to re-use when
// automatically sending to the next nearest driver after a decline.
const _pendingRegistry = {};

export const registerPendingBooking = (bId, requestedType, bookingPayload) => {
  _pendingRegistry[String(bId)] = {
    requestedType,
    payload: bookingPayload,
    excludeVehicleIds: new Set(),
  };
};

const EmployeeBookingAlert = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails, authKey } = useSelector((state) => state.auth);
  const audioContextRef = useRef(null);

  // bookingId → { payload, requestedType, excludeVehicleIds: Set }
  // Keeps track of every active unplanned booking so we can retry with a
  // different driver when the assigned one declines.
  const pendingBookingsRef = useRef({});

  // Connect to Chat WS AND Booking WS
  useEffect(() => {
    if (!userDetails || !authKey) return;

    const role = userDetails.role?.toLowerCase() || ""; 
    const isDriver = role === "driver" || userDetails.role === "D";
    const isAdmin = role === "admin" || role === "ad";
    
    console.log("[EmployeeBookingAlert] Checks - isDriver:", isDriver, "isAdmin:", isAdmin);
     
    if (authKey && userDetails.ServiceNo && !isDriver && !isAdmin) {
      console.log("[EmployeeBookingAlert] ✅ Connecting as Employee/Supervisor");
 
      chatWS.connect(authKey, userDetails.ServiceNo, "Employee");

      const unsubscribeChat = chatWS.onMessage((msg) => {
        console.log("[EmployeeBookingAlert] 📨 Received from ChatWS:", msg);
        processMessage(msg);
      });
 
      bookingWS.connectAsEmployee(authKey);
      
      const unsubscribeBooking = bookingWS.onStatusUpdate((msg) => {
        console.log("[EmployeeBookingAlert] 📨 Received from BookingWS:", msg);
        processMessage(msg);
      });

      return () => {
        if (unsubscribeBooking) unsubscribeBooking();
        if (unsubscribeChat) unsubscribeChat();
         
      };
    }
  }, [authKey, userDetails]);

  const processMessage = (msg) => {
    console.log("[EmployeeBookingAlert] 🔍 Processing message:", msg);
    
 
    if ((msg.type === "status_update" || msg.type === "booking_status_update" || msg.status) && msg.bId) {
      console.log("[EmployeeBookingAlert] ✅ Has bId and status");
      
 
      if (!userDetails?.ServiceNo) {
        console.log("[EmployeeBookingAlert] ❌ Ignoring message - User ServiceNo not available");
        return;
      }
 
      if (msg.type === "status_update") {
        if (!msg.targetUserId || msg.targetUserId === "undefined" || msg.targetUserId === "null") {
          console.log("[EmployeeBookingAlert] ⚠️ Ignoring chat message with missing/invalid targetUserId:", msg.targetUserId);
          return;
        }
        if (String(msg.targetUserId) !== String(userDetails?.ServiceNo)) {
          console.log(`[EmployeeBookingAlert] ❌ Ignoring chat message for user ${msg.targetUserId} (I am ${userDetails?.ServiceNo})`);
          return;
        }
      }
  
      else if (msg.type === "booking_status_update") {
        if (!msg.bookingSno || msg.bookingSno === "undefined" || msg.bookingSno === "null") {
          console.log("[EmployeeBookingAlert] ⚠️ Ignoring booking message with missing/invalid bookingSno:", msg.bookingSno);
          return;
        }
        if (String(msg.bookingSno) !== String(userDetails?.ServiceNo)) {
          console.log(`[EmployeeBookingAlert] ❌ Ignoring booking message for user ${msg.bookingSno} (I am ${userDetails?.ServiceNo})`);
          return;
        }
      }
 
      else {
        if (!msg.targetUserId || msg.targetUserId === "undefined" || msg.targetUserId === "null") {
          console.log("[EmployeeBookingAlert] ⚠️ Ignoring message with missing/invalid targetUserId:", msg.targetUserId);
          return;
        }
        if (String(msg.targetUserId) !== String(userDetails?.ServiceNo)) {
          console.log(`[EmployeeBookingAlert] ❌ Ignoring message for user ${msg.targetUserId} (I am ${userDetails?.ServiceNo})`);
          return;
        }
      }

      console.log("[EmployeeBookingAlert] ✅ Message is for THIS employee! Status:", msg.status);

      if (msg.status === "A" || msg.status === "ACCEPTED") {
        handleAlert("accepted", msg);
      } else if (msg.status === "C" || msg.status === "DECLINED" || msg.status === "REJECTED") {
        handleAlert("declined", msg);
      }
    } else {
      console.log("[EmployeeBookingAlert] ⚠️ Message missing bId or status. Has bId:", !!msg.bId, "Has status:", !!msg.status);
    }
  };

  const playSound = (type) => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      
      const ctx = new AudioContext();
      audioContextRef.current = ctx;
      const now = ctx.currentTime;

      if (type === "accepted") {
        // Success Sound (Positive Chime)
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        
        osc.type = "sine";
        osc.frequency.setValueAtTime(523.25, now); // C5
        osc.frequency.exponentialRampToValueAtTime(1046.5, now + 0.1); // C6
        
        gain.gain.setValueAtTime(0.3, now);
        gain.gain.exponentialRampToValueAtTime(0.01, now + 0.5);
        
        osc.start(now);
        osc.stop(now + 0.5);

        // Harmony
        const osc2 = ctx.createOscillator();
        const gain2 = ctx.createGain();
        osc2.connect(gain2);
        gain2.connect(ctx.destination);
        
        osc2.type = "triangle";
        osc2.frequency.setValueAtTime(659.25, now); // E5
        osc2.frequency.exponentialRampToValueAtTime(1318.5, now + 0.1); // E6
        
        gain2.gain.setValueAtTime(0.3, now);
        gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.5);
        
        osc2.start(now);
        osc2.stop(now + 0.5);

      } else {
        // Decline Sound (Negative/Error)
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.connect(gain);
        gain.connect(ctx.destination);
        
        osc.type = "sawtooth";
        osc.frequency.setValueAtTime(440, now); // A4
        osc.frequency.linearRampToValueAtTime(220, now + 0.3); // A3
        
        gain.gain.setValueAtTime(0.3, now);
        gain.gain.exponentialRampToValueAtTime(0.01, now + 0.4);
        
        osc.start(now);
        osc.stop(now + 0.4);
      }
    } catch (e) {
      console.error("Audio play failed", e);
    }
  };

  // 🔴 UPDATED: Show employee-style toast with button & sound (global notifications)
  const showEmployeeStyleToast = (type, bId) => {
    // Function to play sound (defined inside to avoid conflict)
    const playToastSound = (soundType) => {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;

        const ctx = new AudioContext();
        const now = ctx.currentTime;

        if (soundType === "accepted") {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.type = "sine";
          osc.frequency.setValueAtTime(523.25, now);
          osc.frequency.exponentialRampToValueAtTime(1046.5, now + 0.1);
          gain.gain.setValueAtTime(0.3, now);
          gain.gain.exponentialRampToValueAtTime(0.01, now + 0.5);
          osc.start(now);
          osc.stop(now + 0.5);

          const osc2 = ctx.createOscillator();
          const gain2 = ctx.createGain();
          osc2.connect(gain2);
          gain2.connect(ctx.destination);
          osc2.type = "triangle";
          osc2.frequency.setValueAtTime(659.25, now);
          osc2.frequency.exponentialRampToValueAtTime(1318.5, now + 0.1);
          gain2.gain.setValueAtTime(0.3, now);
          gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.5);
          osc2.start(now);
          osc2.stop(now + 0.5);
        } else {
          const osc = ctx.createOscillator();
          const gain = ctx.createGain();
          osc.connect(gain);
          gain.connect(ctx.destination);
          osc.type = "sawtooth";
          osc.frequency.setValueAtTime(440, now);
          osc.frequency.linearRampToValueAtTime(220, now + 0.3);
          gain.gain.setValueAtTime(0.3, now);
          gain.gain.exponentialRampToValueAtTime(0.01, now + 0.4);
          osc.start(now);
          osc.stop(now + 0.4);
        }
      } catch (e) {
        console.error("Audio play failed", e);
      }
    };

    const message = type === "accepted"
      ? `Driver accepted hire #${bId}. You can see details on my bookings.`
      : `Driver declined hire #${bId}. Try another one.`;

    toast(
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex-1">
          <strong>{type === "accepted" ? "Booking Accepted!" : "Booking Declined"}</strong>
          <div style={{ fontSize: 12 }}>{message}</div>
        </div>
        <div className="flex gap-2">
          {type === "accepted" ? (
            <button
              onClick={() => {
                toast.dismiss();
                // 🔴 FIXED: Navigate to the specific booking details instead of just the bookings list
                // Pass the bId as state or query parameter
                navigate(`/employee/my-bookings?highlight=${bId}&scrollTo=${bId}`, {
                  state: { 
                    highlightBookingId: bId,
                    autoOpenDetails: true 
                  }
                });
              }}
              className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition"
            >
              View Booking
            </button>
          ) : (
            <button
              onClick={() => {
                toast.dismiss();
                navigate("/employee-dashboard");
              }}
              className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition"
            >
              Find Another
            </button>
          )}
        </div>
      </div>,
      {
        autoClose: false,
        closeButton: true,
        position: "top-center",
        style: { minWidth: '400px' }
      }
    );
 
    playToastSound(type);
  };

  const handleAlert = (type, msg) => {
    if (type === "declined") {
      const bId         = String(msg.bId  || "").trim();
      const declinedVId = String(msg.vId  || "").trim();

      const pending = _pendingRegistry[bId];

      if (pending && authKey) {
        // Record this vehicle as declined so it won't be tried again
        if (declinedVId) pending.excludeVehicleIds.add(declinedVId);

        const excludeList = Array.from(pending.excludeVehicleIds);
        console.log(
          `[EmployeeBookingAlert] Driver ${declinedVId} declined booking ${bId}.`,
          `Auto-reassigning. Excluded so far: [${excludeList.join(", ")}]`
        );

        toast.info(`Driver declined booking #${bId}. Finding next available driver...`, {
          autoClose: 4000,
          position: "top-center",
        });

        dispatch(
          FindNearestDriverAndSendRequest(
            bId,
            pending.requestedType,
            pending.payload,
            authKey,
            excludeList
          )
        ).catch((err) => {
          console.error("[EmployeeBookingAlert] No more drivers available:", err.message);
          // All candidates exhausted — inform the employee to re-book
          showEmployeeStyleToast("declined", bId);
          delete _pendingRegistry[bId];
        });
      } else {
        // No stored booking payload (e.g. page reload) — fall back to original toast
        showEmployeeStyleToast("declined", bId);
      }
    } else {
      // Accepted — clean up pending entry and notify employee
      const bId = String(msg.bId || "").trim();
      delete _pendingRegistry[bId];
      showEmployeeStyleToast("accepted", bId);
    }
  };

  return null;
};

export default EmployeeBookingAlert;